import axios from "@/lib/axios";

const getLostNonWarranty = () => {
  return axios.get("/facility/facility_agreements/lost_non_warranty");
}

export default getLostNonWarranty;